import React from 'react'
import { css } from '@emotion/core'
import { RequireText } from '@/components/atoms/require-text'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

type FrontTabletFormLabelProps = {
  label?: React.ReactNode
  required?: boolean
  children?: React.ReactNode
  customFontSize?: number
}

export const FrontTabletFormLabel: React.FC<FrontTabletFormLabelProps> = ({ label, required = false, children, customFontSize }) => {
  return (
    <p css={labelStyle(customFontSize)}>
      {label || ''} {required && <RequireText />}
      {children}
    </p>
  )
}

const labelStyle = (customFontSize?: number) =>
  css(
    {
      fontSize: customFontSize ?? FrontTabletFontSize.formLabel,
      textAlign: 'left',
      letterSpacing: '1.8px',
      color: '#272727',
      fontWeight: 'bold',
      '> span': {
        color: '#F2A40B',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: '0.7px',
      },
    },
    customFontSize === undefined &&
      createSelfCheckinBaseStyle({
        fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape11,
        lineHeight: '24px',
        letterSpacing: '1px',
      }),
    customFontSize === undefined &&
      createSelfCheckinResponsiveStyle({
        landscape13: {
          fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape13,
          lineHeight: '29px',
          letterSpacing: '1.2px',
          '> span': { fontSize: 18, letterSpacing: '0.9px' },
        },
      }),
  )
